<template>
  <div class="offer-search-title">
    <label>
      <span
        v-if="filterTitle !== ''"
        class="offer-search-title__remove"
        @click="resetSearch"
      />
      <input
        type="text"
        :placeholder="trans('offer.name.placeholder')"
        :value="filterTitle"
        @input="debouncedInput"
      >
    </label>
  </div>
</template>

<script>
import { trans } from '@elements/translation';
import { useOfferListStore } from '@stores/useOfferListStore';
import { debounce } from 'lodash-es';
import { storeToRefs } from 'pinia';

export default {
  setup() {
    const store = useOfferListStore();
    const { filterTitle } = storeToRefs(store);
    return {
      filterTitle,
    };
  },
  methods: {
    trans,
    resetSearch() {
      this.filterTitle = '';
    },
    debouncedInput: debounce(function (event) {
      this.filterTitle = event.target.value;
    }, 500),
  },

};
</script>
